import API from "../API";

var Team = {
    async GetFacilitiesTeams() {
        var result = await API.process(
            `api/Team/Teams`,
            'GET',
            null
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async UpsertFacilityTeam(Team) {
        var result = await API.process(
            `api/Team/Team`,
            'POST',
            Team
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async ListPatientAssignments(PatientID, FacilityID) {
        var result = await API.process(
            `api/Team/Patient/${PatientID}/Teams/Facility/${FacilityID}`,
            'GET',
            null
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async AssignPatient(TeamID, PatientID) {
        var result = await API.process(
            `api/Team/${TeamID}/assign/patient/${PatientID}`,
            'POST',
            null
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async RevokePatient(TeamID, PatientID) {
        var result = await API.process(
            `api/Team/${TeamID}/revoke/patient/${PatientID}`,
            'DELETE',
            null
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async AssignMember(TeamID, MemberID, Role) {
        var result = await API.process(
            `api/Team/${TeamID}/assign/member/${MemberID}?role=${Role}`,
            'POST',
            null
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async RevokeMember(TeamID, MemberID) {
        var result = await API.process(
            `api/Team/${TeamID}/revoke/member/${MemberID}`,
            'DELETE',
            null
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async GetTeamPatientIds(TeamID) {
        var result = await API.process(
            `api/Team/${TeamID}/patients`,
            'GET',
            null
        ).catch((err) => {
            throw err;
        })

        return result
    },
}
export default Team;